import { render } from "./BelongsToManyField.vue?vue&type=template&id=2cd59f5c"
import script from "./BelongsToManyField.vue?vue&type=script&lang=js"
export * from "./BelongsToManyField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BelongsToManyField.vue"]])

export default __exports__